import { useState, useCallback } from 'react';
import {
  getPresupuestos, crearPresupuesto, guardarPresupuesto,
  eliminarPresupuesto, duplicarPresupuesto, getConfig, saveConfig,
  getClientes, crearCliente, actualizarCliente, eliminarCliente, ensureClientesSeed,
  getProductos, crearProducto, actualizarProducto, eliminarProducto, ensureProductosSeed,
  ensureConfigSeed,
} from '@/lib/storage';
import type { Presupuesto, EmpresaConfig, Cliente, ProductoServicio } from '@/lib/types';

// Seed demo data y configuración por defecto al arrancar
ensureConfigSeed();
ensureClientesSeed();
ensureProductosSeed();

export function usePresupuestos() {
  const [lista, setLista] = useState<Presupuesto[]>(getPresupuestos);
  const reload = useCallback(() => setLista(getPresupuestos()), []);
  const crear = useCallback((): Presupuesto => { const p = crearPresupuesto(); reload(); return p; }, [reload]);
  const guardar = useCallback((p: Presupuesto) => { guardarPresupuesto(p); reload(); }, [reload]);
  const eliminar = useCallback((id: string) => { eliminarPresupuesto(id); reload(); }, [reload]);
  const duplicar = useCallback((id: string): Presupuesto => { const p = duplicarPresupuesto(id); reload(); return p; }, [reload]);
  return { lista, crear, guardar, eliminar, duplicar };
}

export function useConfig() {
  const [config, setConfig] = useState<EmpresaConfig>(getConfig);
  const update = useCallback((c: Partial<EmpresaConfig>) => { saveConfig(c); setConfig(getConfig()); }, []);
  return { config, update };
}

export function useClientes() {
  const [clientes, setClientes] = useState<Cliente[]>(getClientes);
  const reload = useCallback(() => setClientes(getClientes()), []);
  const crear = useCallback((data: Omit<Cliente, 'id' | 'fechaAlta'>) => { crearCliente(data); reload(); }, [reload]);
  const actualizar = useCallback((c: Cliente) => { actualizarCliente(c); reload(); }, [reload]);
  const eliminar = useCallback((id: string) => { eliminarCliente(id); reload(); }, [reload]);
  return { clientes, crear, actualizar, eliminar };
}

export function useProductos() {
  const [productos, setProductos] = useState<ProductoServicio[]>(getProductos);
  const reload = useCallback(() => setProductos(getProductos()), []);
  const crear = useCallback((data: Omit<ProductoServicio, 'id'>) => { crearProducto(data); reload(); }, [reload]);
  const actualizar = useCallback((p: ProductoServicio) => { actualizarProducto(p); reload(); }, [reload]);
  const eliminar = useCallback((id: string) => { eliminarProducto(id); reload(); }, [reload]);
  return { productos, crear, actualizar, eliminar };
}
